import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/keycloakAuth/AuthContent.tsx";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import { useHistory } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import { Maintenance } from '@gmini/ui-kit';
import { Page403 } from '@gmini/ui-kit/lib/Page403';
import { FetchService } from '@gmini/utils';
import * as api from '@gmini/sm-api-sdk';
import { useStore } from 'effector-react';
import { LoadingPage } from "../components";
import { useMaintenance } from "../hooks/useMaintenance";
import { useForbidden } from "../auth/useForbidden";
import { setKeycloak, tokenData$ } from "./auth";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var AuthContent = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
      appName = _ref.appName;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      pending = _React$useState2[0],
      setPending = _React$useState2[1];

  var history = useHistory();
  var initialUrl = React.useRef('/');
  var tokenData = useStore(tokenData$, {
    loc: {
      file: _effectorFileName,
      line: 23,
      column: 22
    },
    name: "AuthContent",
    sid: "AuthContent /src/keycloakAuth/AuthContent.tsx [23, 22]"
  });

  var _useKeycloak = useKeycloak(),
      initialized = _useKeycloak.initialized,
      keycloak = _useKeycloak.keycloak;

  React.useEffect(function () {
    var currentPathname = history.location.pathname;
    initialUrl.current = currentPathname;
  }, [history]);

  var _useForbidden = useForbidden(React.useMemo(function () {
    return {
      fetchServiceClass: FetchService
    };
  }, [])),
      isForbiddenData = _useForbidden.isForbiddenData,
      clearForbidden = _useForbidden.clearForbidden;

  React.useEffect(function () {
    return function () {
      setPending(false);
      clearForbidden();
    };
  }, [clearForbidden]);
  React.useEffect(function () {
    if (keycloak.authenticated && tokenData !== null && tokenData !== void 0 && tokenData.accessToken) {
      api.Auth.User.fetch.defaultContext(undefined);
    }
  }, [keycloak.authenticated, tokenData === null || tokenData === void 0 ? void 0 : tokenData.accessToken]);
  React.useEffect(function () {
    setKeycloak(keycloak);
  }, [keycloak]);

  var _useMaintenance = useMaintenance({
    fetchServiceClass: FetchService
  }),
      maintenanceEnabled = _useMaintenance.maintenanceEnabled;

  var onReload = React.useCallback(function () {
    window.location.reload();
  }, []);
  var onMainPage = React.useCallback(function () {
    clearForbidden();
    history.push('/');
  }, [history, clearForbidden]);
  var onLogout = React.useCallback(function () {
    setPending(true);
    keycloak.logout();
  }, [keycloak]);

  if (!initialized || pending) {
    return /*#__PURE__*/_jsx(LoadingPage, {});
  }

  if (isForbiddenData) {
    return /*#__PURE__*/_jsx(Page403, {
      onReload: onReload,
      onMainPage: onMainPage,
      onLogout: onLogout
    });
  }

  if (maintenanceEnabled) {
    return /*#__PURE__*/_jsx(Maintenance, {});
  }

  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
});
AuthContent.displayName = 'AuthContent';